export const DEV: boolean = process.env.NODE_ENV !== 'production';
export const GQL_HOST: string = process.env.REACT_APP_GQL_HOST || 'http://127.0.0.1:8000/graphql';
